(() => {
    "use strict";

    const BANNER_ID = "shopify-pc__banner";
    const OVERLAY_ID = "cookie-lock-overlay";

    let locked = false;
    let bannerObserver = null;

    let isShaking = false;
    let shakeResetTimer = null;

    function getBanner() {
        return document.getElementById(BANNER_ID);
    }

    function bannerIsVisible() {

        const banner = getBanner();

        if (!banner || !banner.isConnected) {
            return false;
        }

        const style = window.getComputedStyle(banner);

        return (
            !banner.hidden &&
            style.display !== "none" &&
            style.visibility !== "hidden"
        );

    }

    function isBannerElement(target) {

        if (!(target instanceof Element)) {
            return false;
        }

        return Boolean(
            target.closest(
                "#shopify-pc__banner,[id^='shopify-pc__'],[class*='shopify-pc__']"
            )
        );

    }

    function shakeBanner() {

        const banner = getBanner();

        if (!banner) return;

        if (isShaking) {

            clearTimeout(shakeResetTimer);

            shakeResetTimer = setTimeout(() => {

                isShaking = false;

            }, 350);

            return;

        }

        isShaking = true;

        banner.classList.remove("cookie-shake");

        void banner.offsetWidth;

        banner.classList.add("cookie-shake");

        shakeResetTimer = setTimeout(() => {

            banner.classList.remove("cookie-shake");
            isShaking = false;

        }, 450);

    }

    function preventPointer(event) {

        if (!locked) return;

        if (isBannerElement(event.target)) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        shakeBanner();

    }

    function preventWheel(event) {

        if (!locked) return;

        if (isBannerElement(event.target)) return;

        event.preventDefault();
        event.stopPropagation();

        shakeBanner();

    }

    function preventKeyboard(event) {

        if (!locked) return;

        const blockedKeys = [
            "ArrowUp",
            "ArrowDown",
            "ArrowLeft",
            "ArrowRight",
            "PageUp",
            "PageDown",
            "Home",
            "End",
            " "
        ];

        if (!blockedKeys.includes(event.key)) return;

        event.preventDefault();
        event.stopPropagation();

        shakeBanner();

    }

    function addListeners() {

        document.addEventListener("click", preventPointer, true);

        document.addEventListener("pointerdown", preventPointer, true);

        document.addEventListener("wheel", preventWheel, {
            capture: true,
            passive: false
        });

        document.addEventListener("touchmove", preventWheel, {
            capture: true,
            passive: false
        });

        document.addEventListener("keydown", preventKeyboard, true);

    }

    function removeListeners() {

        document.removeEventListener("click", preventPointer, true);
        document.removeEventListener("pointerdown", preventPointer, true);
        document.removeEventListener("wheel", preventWheel, true);
        document.removeEventListener("touchmove", preventWheel, true);
        document.removeEventListener("keydown", preventKeyboard, true);

    }

    function lockPage() {

        if (locked) return;

        locked = true;

        document.documentElement.classList.add("cookie-lock");

        if (!document.getElementById(OVERLAY_ID)) {

            const overlay = document.createElement("div");

            overlay.id = OVERLAY_ID;

            overlay.addEventListener("click", shakeBanner);

            document.body.appendChild(overlay);

        }

        addListeners();

    }

    function unlockPage() {

        if (!locked) return;

        locked = false;

        document.documentElement.classList.remove("cookie-lock");

        document.getElementById(OVERLAY_ID)?.remove();

        removeListeners();

        bannerObserver?.disconnect();

    }

    function watchBanner() {

        const banner = getBanner();

        if (!banner) return;

        lockPage();

        bannerObserver = new MutationObserver(() => {

            if (!bannerIsVisible()) {

                unlockPage();

            }

        });

        bannerObserver.observe(banner, {
            attributes: true,
            attributeFilter: [
                "style",
                "hidden",
                "class"
            ]
        });

    }

    function init() {

        if (getBanner()) {

            watchBanner();

            return;

        }

        const observer = new MutationObserver(() => {

            if (!getBanner()) return;

            observer.disconnect();

            watchBanner();

        });

        observer.observe(document.documentElement, {
            childList: true,
            subtree: true
        });

    }

    if (document.readyState === "loading") {

        document.addEventListener("DOMContentLoaded", init, {
            once: true
        });

    } else {

        init();

    }

})();